import { emptyText, okText } from "../../../i18n/text/common.js";
import { abortedText, decodeText, encryptedText, networkText, sourceText, titleText, unexpectedText, unplayableText } from "../../../i18n/text/errors.js";
import { MediaError } from "@videojs/media";
//#region src/core/ui/error-dialog/i18n.ts
/**
* SVTA 99 [Custom] 001 — an engine reporting that it has no pipeline for something the source requires. Not a
* `MediaError.MEDIA_ERR_*` value: engines that report SVTA codes surface them on `error.code` directly.
*
* The literal rather than an import. `@videojs/spf` defines this as `SVTA_UNSUPPORTED_PLAYBACK_FEATURE` and owns its
* meaning, but core doesn't depend on spf, and reaching it through `@videojs/media` would pull an engine entry point
* into a barrel that has no other reason to load one. Same trade `HlsVideoMediaStreamType` makes in the other direction
* — compatibility by value, stated in a comment, instead of a dependency edge neither package wants.
*/
const SVTA_UNSUPPORTED_PLAYBACK_FEATURE = 99001;
const MEDIA_ERROR_TRANSLATIONS = {
	[MediaError.MEDIA_ERR_ABORTED]: abortedText,
	[MediaError.MEDIA_ERR_NETWORK]: networkText,
	[MediaError.MEDIA_ERR_DECODE]: decodeText,
	[MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED]: sourceText,
	[MediaError.MEDIA_ERR_ENCRYPTED]: encryptedText,
	[MediaError.MEDIA_ERR_CUSTOM]: emptyText,
	[SVTA_UNSUPPORTED_PLAYBACK_FEATURE]: unplayableText
};
const STANDARD_CODE_UA_MESSAGES = { [MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED]: ["Failed to open media"] };
function isStandardMediaErrorCode(code) {
	return code >= MediaError.MEDIA_ERR_ABORTED && code <= MediaError.MEDIA_ERR_ENCRYPTED;
}
function getMediaErrorTranslationKey(code) {
	return MEDIA_ERROR_TRANSLATIONS[code]?.key;
}
function getErrorDialogTitleText() {
	return titleText;
}
function getErrorDialogDismissText() {
	return okText;
}
function getErrorDialogUnexpectedText() {
	return unexpectedText;
}
/**
* Resolves dialog body copy: default phrases for known {@link MediaError} defaults, literal text for custom messages,
* otherwise the generic fallback key.
*/
function resolveErrorDialogDescription(error, cachedMessage) {
	if (error) {
		const text = MEDIA_ERROR_TRANSLATIONS[error.code];
		const message = error.message?.trim();
		if (message) {
			const defaultForCode = MediaError.defaultMessages[error.code];
			if (text && defaultForCode && message === defaultForCode) return text;
			const uaVariants = STANDARD_CODE_UA_MESSAGES[error.code];
			if (text && isStandardMediaErrorCode(error.code) && !error.context && uaVariants?.includes(message)) return text;
			return message;
		}
		if (text) return text;
	}
	const cached = cachedMessage?.trim();
	if (cached) return cached;
	return unexpectedText;
}
//#endregion
export { getErrorDialogDismissText, getErrorDialogTitleText, getErrorDialogUnexpectedText, getMediaErrorTranslationKey, resolveErrorDialogDescription };

//# sourceMappingURL=i18n.js.map